// ** Reducers Imports
import layout from "./layout"
import navbar from "./navbar"
import auth from './authentication'
import swagger from "./swagger"

const rootReducer = {
    navbar,
    layout,
    auth,
    swagger
}

export default rootReducer
